export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';

export function addNotification(notification) {
    return {
        type: ADD_NOTIFICATION,
        notification
    };
}

export function resetNotifications() {
    return {
        type: RESET_NOTIFICATIONS
    };
}



// WEBPACK FOOTER //
// ./src/actions/notifications.js